webpackJsonp([1],{

/***/ "+mLZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+v5J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("/5vk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7909bce6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("GMZ5");
function injectStyle (ssrContext) {
  __webpack_require__("0k5H")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7909bce6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/5vk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css__ = __webpack_require__("miO0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_indicator_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator__ = __webpack_require__("OTYB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast_style_css__ = __webpack_require__("PBmY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast__ = __webpack_require__("I4Nl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_field_style_css__ = __webpack_require__("RTFJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_field_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_field_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_field__ = __webpack_require__("s9Cd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_button_style_css__ = __webpack_require__("8O0P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_button_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_button_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_button__ = __webpack_require__("rxcl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_header_style_css__ = __webpack_require__("vKIO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_header_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_header_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_header__ = __webpack_require__("GQr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__("yf3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__interface__ = __webpack_require__("wtao");










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import { Button } from 'mint-ui';

__WEBPACK_IMPORTED_MODULE_10_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_header___default.a.name, __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_header___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_10_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_field___default.a.name, __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_field___default.a);
// Vue.use(Field)
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      I18n: window.I18n,
      email: '',
      policyNo: '',
      btnDisable: false
    };
  },

  methods: {
    handleSend: function handleSend() {
      var _this = this;

      var mailReg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      var isLegal = mailReg.test(this.email);
      if (!isLegal) {
        __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast___default()({
          message: 'Please enter the correct email format',
          iconClass: 'icon icon-error'
        });
      }
      if (isLegal) {
        __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default.a.open({
          text: 'Sending...',
          spinnerType: 'fading-circle'
        });
        this.btnDisable = true;
        __WEBPACK_IMPORTED_MODULE_11__interface__["a" /* default */].getPolicyeBook({ policyId: this.policyId, receiverEmail: this.email }).then(function (data) {
          _this.btnDisable = false;
          __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_indicator___default.a.close();
          if (data.error === 'SUCCESS') {
            _this.$router.push({
              name: 'SendSuccess',
              query: { policyId: _this.policyId }
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_toast___default()({
              message: 'Send mail fail!',
              iconClass: 'icon icon-error'
            });
          }
        });
      }
    }
  },
  created: function created() {
    this.policyId = this.$route.query.policyId;
  }
});

/***/ }),

/***/ "0k5H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0xPk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2hKG":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "7U57":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8O0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8r72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("T26o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_52faa5eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("F5RM");
function injectStyle (ssrContext) {
  __webpack_require__("9WYl")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_52faa5eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9WYl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9bN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

/**
 * ajax 模块，可以将 axios 替换成 $.ajax 等
 */

// import globalConfig from '../config'

var GET_I18N = '/static/i18n/';
var init = function init() {
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
    if (config.url.indexOf(GET_I18N) < 0) {
      config.url = window.localStorage.gatewayDomain + config.url;
    }
    // var cookies = globalConfig.getCookies()
    // config.url += ('access_token=' + cookies['access_token'])
    if (!config.data) config.data = {};
    return config;
  }, function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
    // return (err)
  });

  // Add a response interceptor
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
    var status = response.status,
        data = response.data;


    if (status === 200) {
      // 如果不出现错误，直接向回调函数内输出 data
      if (data.error === 'SUCCESS') {
        return data;
      } else {
        return data;
      }
    } else {
      return response;
    }
  }, function (error) {
    var response = error.response;

    // 这里处理错误的 http code

    if (!response || response.status === 404) {
      console.log('404 error %o' + error);
    }
    // return (error)
    // Do something with response error
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  init: init
});

/***/ }),

/***/ "F5RM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"policydetail-wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"empty border-1px"}),_vm._v(" "),_c('div',{staticClass:"companyInfo border-1px"},[_c('img',{attrs:{"src":__webpack_require__("mFMo"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"insuranceInfo"},[_vm._v("\n        ”Auspicious Travel” Visiting Tourist Personal Accident Insurance\n        "),_c('p',[_vm._v("Application from No. : "+_vm._s(_vm.userInfo.policyNo))])])]),_vm._v(" "),_c('div',{staticClass:"empty border-1px"}),_vm._v(" "),_c('div',{staticClass:"personInfo"},[_c('mt-field',{attrs:{"label":"Applicant","placeholder":"","readonly":""},model:{value:(_vm.userInfo.applicantName),callback:function ($$v) {_vm.$set(_vm.userInfo, "applicantName", $$v)},expression:"userInfo.applicantName"}}),_vm._v(" "),_c('mt-field',{attrs:{"label":"Insured","placeholder":"","readonly":""},model:{value:(_vm.userInfo.insuredName),callback:function ($$v) {_vm.$set(_vm.userInfo, "insuredName", $$v)},expression:"userInfo.insuredName"}}),_vm._v(" "),_c('mt-field',{attrs:{"label":"Type of ID","placeholder":"","readonly":""},model:{value:(_vm.idType),callback:function ($$v) {_vm.idType=$$v},expression:"idType"}}),_vm._v(" "),_c('mt-field',{attrs:{"label":"ID number","placeholder":"","readonly":""},model:{value:(_vm.userInfo.idNo),callback:function ($$v) {_vm.$set(_vm.userInfo, "idNo", $$v)},expression:"userInfo.idNo"}}),_vm._v(" "),_c('mt-field',{attrs:{"label":"Date of entry","placeholder":"","readonly":""},model:{value:(_vm.userInfo.approveDate),callback:function ($$v) {_vm.$set(_vm.userInfo, "approveDate", $$v)},expression:"userInfo.approveDate"}})],1),_vm._v(" "),_c('div',{staticClass:"empty border-1px"}),_vm._v(" "),_c('div',{staticClass:"personInfo"},[_c('mt-field',{attrs:{"label":"Insurance period","placeholder":"","readonly":""},model:{value:(_vm.period),callback:function ($$v) {_vm.period=$$v},expression:"period"}}),_vm._v(" "),_c('mt-field',{attrs:{"label":"Permium","placeholder":"","readonly":""},model:{value:(_vm.userInfo.permium),callback:function ($$v) {_vm.$set(_vm.userInfo, "permium", $$v)},expression:"userInfo.permium"}})],1),_vm._v(" "),_c('div',{staticClass:"empty border-1px"}),_vm._v(" "),_c('mt-cell',{attrs:{"title":"Insurance cluase","is-link":"","to":_vm.tourl},nativeOn:{"click":function($event){return _vm.handleGo.apply(null, arguments)}}}),_vm._v(" "),_c('div',{staticClass:"empty border-1px"}),_vm._v(" "),_c('div',{staticClass:"sendBtnWrap"},[_c('mt-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){return _vm.handlePrint.apply(null, arguments)}}},[_vm._v("Download policy")]),_vm._v(" "),_c('mt-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){return _vm.handleSend.apply(null, arguments)}}},[_vm._v("Send to email")])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"top-head border-1px"},[_c('h1',[_vm._v("Policy detail")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fhwq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"verify-wrap"},[_c('p',[_vm._v("Policy verification")]),_vm._v(" "),_c('div',{staticClass:"blankLine border-1px"}),_vm._v(" "),_c('div',{staticClass:"infoWarp"},[_c('div',{staticClass:"inputInfoWrap"},[_c('img',{attrs:{"src":__webpack_require__("U4aM"),"alt":""}}),_vm._v(" "),_c('mt-field',{staticClass:"info border-1px",attrs:{"placeholder":"Passport number","type":"text"},model:{value:(_vm.idNo),callback:function ($$v) {_vm.idNo=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"idNo"}})],1),_vm._v(" "),_c('div',{staticClass:"inputInfoWrap"},[_c('img',{attrs:{"src":__webpack_require__("Qwxi"),"alt":""}}),_vm._v(" "),_c('mt-field',{staticClass:"info border-1px",attrs:{"placeholder":"Verification code","type":"text"},model:{value:(_vm.vncode),callback:function ($$v) {_vm.vncode=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"vncode"}})],1),_vm._v(" "),_c('div',{staticClass:"searchBtn"},[_c('mt-button',{class:!_vm.idNo? '': 'active',attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.handleSearch.apply(null, arguments)}}},[_vm._v("Search")])],1),_vm._v(" "),_c('div',{staticClass:"demoWrap",on:{"click":function($event){_vm.isShowDemo=true}}},[_c('img',{attrs:{"src":__webpack_require__("zcWg"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("Verification demo")])])])]),_vm._v(" "),(_vm.isShowDemo)?_c('div',{staticClass:"demomaskWrap"},[_c('div',{staticClass:"demomask"},[_c('div',{staticClass:"demotop"}),_vm._v(" "),_c('div',{staticClass:"demofoot",on:{"click":function($event){_vm.isShowDemo=false}}},[_c('p',[_vm._v("I know")])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GMZ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"clause-wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"empty border-1px"}),_vm._v(" "),_c('div',{staticClass:"emailInfo"},[_c('mt-field',{attrs:{"label":"Email","placeholder":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"email"}})],1),_vm._v(" "),_c('div',{staticClass:"sendmailwrap"},[_c('mt-button',{class:!_vm.email? '': 'active',attrs:{"disabled":_vm.btnDisable,"type":"default"},nativeOn:{"click":function($event){return _vm.handleSend.apply(null, arguments)}}},[_vm._v("Send")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"top-head border-1px"},[_c('h1',[_vm._v("Email")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("sEFh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_bfc7dcea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("idQT");
function injectStyle (ssrContext) {
  __webpack_require__("vTlb")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bfc7dcea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_bfc7dcea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_button_style_css__ = __webpack_require__("8O0P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_button_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_button_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_button__ = __webpack_require__("rxcl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("yf3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ajax__ = __webpack_require__("9bN/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_request__ = __webpack_require__("fiA/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__interface__ = __webpack_require__("wtao");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fastclick__ = __webpack_require__("iDdd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_all_styl__ = __webpack_require__("0xPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_all_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style_all_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_common_css_pages_css__ = __webpack_require__("sywW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_common_css_pages_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_common_css_pages_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__("QmSG");


// 此处后续替换为修改过样式











// 注册全局组件标签
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_button___default.a);

// mock 启动
__webpack_require__("qs/E");
// if (/192\.168\.2\.27/.test(location.href)) {
//   require('@/mock');
// }
// 全局变量http://pmh.gc-life.com/
window.localStorage.permissionCheckUrl = 'platform/v1/access/resources';
window.localStorage.defaultLanguage = 'EN_US';

// 动态设置环境
console.log("production");
if (false) {
  // dev环境
  window.localStorage.gatewayDomain = 'https://dev-api.zjlh.lan/';
  window.localStorage.serviceName = 'https://dev-bmp-apply.zjlh.lan';
  window.localStorage.loginUrl = 'https://dev-bmp.zjlh.lan';
  window.localStorage.dashboardUrl = 'https://dev-bmp.zjlh.lan/#/dashboard';
  window.localStorage.cookieDomain = '.zjlh.lan';
} else if (false) {
  // stag预发布环境
  window.localStorage.gatewayDomain = 'https://stag-api.gc-life.cn/';
  window.localStorage.serviceName = 'https://stag-bmp-apply.gc-life.cn';
  window.localStorage.loginUrl = 'https://stag-bmp.gc-life.cn';
  window.localStorage.dashboardUrl = 'https://stag-bmp.gc-life.cn/#/dashboard';
  window.localStorage.cookieDomain = '.gc-life.cn';
} else if (true) {
  // 生产环境
  window.localStorage.gatewayDomain = 'https://api.gc-life.com/';
  window.localStorage.serviceName = 'https://bmp-apply.gc-life.com';
  window.localStorage.loginUrl = 'https://bmp.gc-life.com/#/';
  window.localStorage.dashboardUrl = 'https://bmp.gc-life.com/#/dashboard';
  window.localStorage.cookieDomain = '.gc-life.com';
}
console.log(window.localStorage.gatewayDomain);

// 插件配置
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
// 清除点击事件300ms延迟
if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function () {
    __WEBPACK_IMPORTED_MODULE_8_fastclick___default.a.attach(document.body);
  }, false);
}
// 配置初始化
// config.init()
// axios 统一配置
__WEBPACK_IMPORTED_MODULE_5__services_ajax__["a" /* default */].init();

// 设置请求头
__WEBPACK_IMPORTED_MODULE_6__services_request__["a" /* default */].init();

// 此处调用国际化接口，获取国际化数据
var language = __WEBPACK_IMPORTED_MODULE_11__config__["a" /* default */].getCookie('language');
if (!language || !language.length) {
  language = window.localStorage.defaultLanguage;
}
// 此处调用国际化接口，获取国际化数据
// INTERFACE.getI18nType().then((data) => {
__WEBPACK_IMPORTED_MODULE_7__interface__["a" /* default */].getI18n(language).then(function () {
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
  });
});
// })

/***/ }),

/***/ "NZf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("ZxTN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_92e347ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("mvM6");
function injectStyle (ssrContext) {
  __webpack_require__("wVPr")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_92e347ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PBmY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Phrt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import router from './router/index'
// import axios from 'axios'

// const init = function () {
//   router.beforeEach((to, from, next) => {
//     if (to.matched && to.matched.length && to.matched[0].path) {
//       checkPermission(to.matched[0].path).then(data => {
//         if (data.data === 'true') {
//           next()
//         }
//       })
//     } else {
//       checkPermission(to.path).then(data => {
//         if (data.data === 'true') {
//           next()
//         }
//       })
//     }
//   })
// }

// Return the document's cookies as an object of name/value pairs.
function getCookies() {
  var cookies = {};
  var all = document.cookie;
  if (all === '') return cookies;
  var list = all.split('; ');
  for (var i = 0; i < list.length; i++) {
    var cookie = list[i];
    var p = cookie.indexOf('=');
    var name = cookie.substring(0, p);
    var value = cookie.substring(p + 1);
    value = decodeURIComponent(value);
    cookies[name] = value;
  }
  return cookies;
}

function getCookie(name) {
  var cookies = getCookies();
  var value = '';
  if (cookies && cookies[name]) {
    value = cookies[name];
  }
  return value;
}

function clearCookie() {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  document.cookie = 'access_token' + '=;domain=' + window.localStorage.cookieDomain + ';expires=' + exp.toGMTString() + ';path=/';
  document.cookie = 'username' + '=;domain=' + window.localStorage.cookieDomain + ';expires=' + exp.toGMTString() + ';path=/';
  document.cookie = 'language' + '=;domain=' + window.localStorage.cookieDomain + ';expires=' + exp.toGMTString() + ';path=/';
}

// set cookie
function setCookie(name, value) {
  var cookie = name + '=' + encodeURIComponent(value);
  document.cookie = cookie;
}

// function checkPermission(path) {
//   return axios.get(window.localStorage.permissionCheckUrl + '?', {
//     params: {
//       requestUrl: path,
//       httpMethod: 'GET',
//       serviceName: window.localStorage.serviceName,
//       type: 'FRONTEND_URL'
//     }
//   })
// }

/* harmony default export */ __webpack_exports__["a"] = ({
  getCookies: getCookies,
  setCookie: setCookie,
  getCookie: getCookie,
  clearCookie: clearCookie
});

/***/ }),

/***/ "Qwxi":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAtCAYAAAC53tuhAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo3MjE5NUE3RjBDMEQxMUU4ODEyOEQxRkY1QTAwQUU5MyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo3MjE5NUE4MDBDMEQxMUU4ODEyOEQxRkY1QTAwQUU5MyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjcyMTk1QTdEMEMwRDExRTg4MTI4RDFGRjVBMDBBRTkzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjcyMTk1QTdFMEMwRDExRTg4MTI4RDFGRjVBMDBBRTkzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+3JnrMgAAAg5JREFUeNrsmL9LW0EcwN/TiFYIToIObaCDtqJO4hKQjsXSJZuapRTzF6SIBS21oBD8C1KEDlE3F2kpTiK4iEuMKDoI6lJwEQKtUtr4+eL3wRHeq2/wIoU7+OTue78+d0lecpzvGSmTzfWSZaEHWr37SddwDKW1UvEoqPRVKPkMzEKzZyf9gTn4xAJqCa18Bx/hXOXb8PuehC2QVqk4rqDgs9tuCifwA4ZZzYWN7eLpJNuBLnjaxMsYtEHellSSzp1X15iIh+AvfPPsp6/qGhJxO1RZ0S/bVhzy+VbF2eQ9UHJiJ3ZiJ3bi2CkRVpleqsmJZAAut9/6ZxF95Hjk0X4c0f6ErAP26VO7c8cMkP/LTSjDKfF8/aJgmaKcn46krAs1+8iYU9iTuYgfxXmrczBixNMMHDDi1zBuxONaF0il77TRLnNNxhH3h9Q9N8p9Ie19EX0j5wwT74fUHRrlg5D2ckTfIFXiiD/DlhEv8OUwB67DihF/ge9BoH0XjPYNKN4pZqAcgV7AIKSI39e112CCohz+eym/qf/W6piUzvGS+DrW46QTVf71HEY9Rkb7mfvlcmIndmIn/v/FPyGZyebabMtwyBEoKU4R7+oCXjVgo6Pq2pWXVb0CWtSbGVu7lbkX1bUaXLDJPVfBs3/P9Rim1krFgm+s6IN3e7vXkJs9v+7teEYmxxrrd5k3AgwAAqOpbN6jffcAAAAASUVORK5CYII="

/***/ }),

/***/ "RTFJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SUzx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T26o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_infinite_scroll_style_css__ = __webpack_require__("Phrt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_infinite_scroll_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_infinite_scroll_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_infinite_scroll__ = __webpack_require__("XyCN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_popup_style_css__ = __webpack_require__("pIlK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_popup_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_popup_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_popup__ = __webpack_require__("0Qqo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_popup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_popup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_cell_style_css__ = __webpack_require__("SUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_cell_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_cell_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_cell__ = __webpack_require__("cfQL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_radio_style_css__ = __webpack_require__("+mLZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_radio_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_radio_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_radio__ = __webpack_require__("nqp9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_field_style_css__ = __webpack_require__("RTFJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_field_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_field_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_field__ = __webpack_require__("s9Cd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_button_style_css__ = __webpack_require__("8O0P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_button_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mint_ui_lib_button_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_button__ = __webpack_require__("rxcl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_header_style_css__ = __webpack_require__("vKIO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_header_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_mint_ui_lib_header_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_header__ = __webpack_require__("GQr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__("yf3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__interface__ = __webpack_require__("wtao");














//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import { Button } from 'mint-ui';

__WEBPACK_IMPORTED_MODULE_14_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_header___default.a.name, __WEBPACK_IMPORTED_MODULE_13_mint_ui_lib_header___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_11_mint_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_field___default.a.name, __WEBPACK_IMPORTED_MODULE_9_mint_ui_lib_field___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_radio___default.a.name, __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_radio___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_cell___default.a.name, __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_cell___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_popup___default.a.name, __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_popup___default.a);
__WEBPACK_IMPORTED_MODULE_14_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_infinite_scroll___default.a);
// Vue.use(Field)
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'insurancePolicy',
  data: function data() {
    return {
      I18n: window.I18n,
      tourl: '',
      username: 'Policy verification',
      policyId: '',
      period: 'Refer to the insurance clause in detail',
      idType: 'PASSPORT',
      focusState: false,
      filename: 'httpclient-tutorial.pdf',
      userInfo: {
        applicantName: '',
        insuredName: '',
        sex: '',
        nationality: '',
        birthday: '',
        permium: '',
        policyNo: ''
      }
    };
  },
  created: function created() {
    var _this = this;

    // this.policyId = this.$route.params.policyId || ''
    this.policyId = this.$route.query.policyId;
    __WEBPACK_IMPORTED_MODULE_15__interface__["a" /* default */].getPolicyDetail({ policyId: this.policyId }).then(function (data) {
      if (data.data) {
        data.data.approveDate = _this.getDate(data.data.approveDate);
        data.data.birthday = _this.getDate(data.data.birthday);
        _this.userInfo = data.data;
        _this.userInfo.permium = data.data.currencyCode + data.data.periodTotalPremium;
        _this.tourl = 'http://release-oss.gc-life.com/gclife/product/jxtx/clause.html';
      }
    });
  },

  methods: {
    handleSend: function handleSend() {
      this.$router.push({
        path: '/SendEmail',
        query: { policyId: this.policyId }
      });
    },
    handleGo: function handleGo() {
      window.location.href = 'http://gclife-hk-release.oss-cn-hongkong.aliyuncs.com/gclife/agent/agreement/content.html';
    },
    getDate: function getDate(value) {
      var date = new Date(+value);
      return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate();
    },
    handlePrint: function handlePrint() {
      window.location.href = window.localStorage.gatewayDomain + 'policy/v1/policy/download?policyId=' + this.policyId;
    }
  }
});

/***/ }),

/***/ "U4aM":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ULuq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X4W6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("lcpl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_59253f66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("Fhwq");
function injectStyle (ssrContext) {
  __webpack_require__("7U57")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_59253f66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("yf3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("mB6C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_InsurancePolicy_index_vue__ = __webpack_require__("X4W6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_PolicyDetail_index_vue__ = __webpack_require__("8r72");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_SendEmail_index_vue__ = __webpack_require__("+v5J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_SendSuccess_index_vue__ = __webpack_require__("NZf9");








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/p/v',
    name: 'InsurancePolicy',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_InsurancePolicy_index_vue__["a" /* default */]
  }, {
    path: '/policydetail',
    name: 'PolicyDetail',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_PolicyDetail_index_vue__["a" /* default */]
  }, {
    path: '/SendEmail',
    name: 'SendEmail',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_SendEmail_index_vue__["a" /* default */]
  }, {
    path: '/SendSuccess',
    name: 'SendSuccess',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_SendSuccess_index_vue__["a" /* default */]
  }]
}));

/***/ }),

/***/ "YhU3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZxTN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_button_style_css__ = __webpack_require__("8O0P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_button_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_button_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_button__ = __webpack_require__("rxcl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_header_style_css__ = __webpack_require__("vKIO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_header_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_header_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_header__ = __webpack_require__("GQr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("yf3K");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { Button } from 'mint-ui';

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_header___default.a.name, __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_header___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_button___default.a);
// Vue.use(Field)
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'insurancePolicy',
  data: function data() {
    return {
      I18n: window.I18n,
      username: 'Policy verification',
      email: '',
      password: '',
      phone: '',
      website: '',
      number: '',
      birthday: '',
      introduction: ''
    };
  },

  methods: {
    handleReturn: function handleReturn() {
      this.$router.push({
        name: 'PolicyDetail',
        query: { policyId: this.policyId }
      });
    }
  },
  created: function created() {
    this.policyId = this.$route.query.policyId;
  }
});

/***/ }),

/***/ "fiA/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/**
 * Created by c0001 on 2018/6/15.
 */


// 设置公共请求头
var init = function init() {
  var url = window.location.search.toString();
  var arr = [];
  var isArr = {};
  arr = url.split('&');
  arr.forEach(function (l) {
    l = l.split('=');
    isArr[l[0]] = l[1];
  });
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['deviceChannel'] = 'gclife_bmp_pc';
  __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['language'] = window.localStorage.defaultLanguage;
  if (isArr.osType) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['osType'] = isArr.osType;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['osType'] = '';
  };
  if (isArr.deviceId) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['deviceId'] = isArr.deviceId;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['deviceId'] = '';
  };
  if (isArr.appVersion) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['appVersion'] = isArr.appVersion;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['appVersion'] = '';
  };
  if (isArr.district) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['district'] = isArr.district;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['district'] = '';
  };
  if (isArr.phoneModel) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['phoneModel'] = isArr.phoneModel;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['phoneModel'] = '';
  };
  if (isArr.osVersion) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['osVersion'] = isArr.osVersion;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['osVersion'] = '';
  };
  if (isArr.coordiate) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['coordiate'] = isArr.coordiate;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['coordiate'] = '';
  };
  if (isArr.networkType) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['networkType'] = isArr.networkType;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['networkType'] = '';
  };
  if (isArr.ipAddress) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['ipAddress'] = isArr.ipAddress;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['ipAddress'] = '';
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  init: init
});

/***/ }),

/***/ "idQT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lcpl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__ = __webpack_require__("PBmY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__ = __webpack_require__("I4Nl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_radio_style_css__ = __webpack_require__("+mLZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_radio_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_radio_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_radio__ = __webpack_require__("nqp9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_field_style_css__ = __webpack_require__("RTFJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_field_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui_lib_field_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_field__ = __webpack_require__("s9Cd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_button_style_css__ = __webpack_require__("8O0P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_button_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui_lib_button_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_button__ = __webpack_require__("rxcl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("yf3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__interface__ = __webpack_require__("wtao");








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_8_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_button___default.a.name, __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_field___default.a.name, __WEBPACK_IMPORTED_MODULE_5_mint_ui_lib_field___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_radio___default.a.name, __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_radio___default.a);
// Vue.use(Field)
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isShowDemo: true,
      I18n: window.I18n,
      username: 'Policy verification',
      idNo: '',
      vncode: '',
      password: '',
      phone: '',
      website: '',
      number: '',
      birthday: '',
      verifyNo: '',
      introduction: ''
    };
  },

  watch: {},
  methods: {
    handleSearch: function handleSearch() {
      var _this = this;

      if (!this.idNo) {
        __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()({
          message: 'Please enter your passport number!',
          iconClass: 'icon icon-error'
        });
        return;
      }
      if (!this.vncode) {
        __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()({
          message: 'Please enter your Verification code!',
          iconClass: 'icon icon-error'
        });
        return;
      }
      __WEBPACK_IMPORTED_MODULE_9__interface__["a" /* default */].getPolicyIstrue({ verifyNo: this.vncode.toUpperCase(), idNo: this.idNo.toUpperCase() }).then(function (data) {
        if (data.data && data.data.policyId) {
          _this.$router.push({
            path: '/policydetail',
            query: { policyId: data.data.policyId }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast___default()({
            message: 'No Policy Found!',
            iconClass: 'icon icon-error'
          });
        }
      });
    }
  },
  created: function created() {}
});

/***/ }),

/***/ "mFMo":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "miO0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mvM6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"clause-wrap"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"sendsuccesswrap"},[_c('mt-button',{attrs:{"type":"default"},nativeOn:{"click":function($event){return _vm.handleReturn.apply(null, arguments)}}},[_vm._v("Return to Policy detail")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"top-head border-1px"},[_c('h1',[_vm._v("Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imgwrap"},[_c('img',{attrs:{"src":__webpack_require__("2hKG"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msgWrap"},[_c('h2',[_vm._v("Successfully sent")]),_vm._v(" "),_c('p',[_vm._v("Your policy will be sent to your email within 60 minutes.\n       Please log in to your email to download\n     ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pIlK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qs/E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs__ = __webpack_require__("v4dE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mockjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mockjs__);


__WEBPACK_IMPORTED_MODULE_0_mockjs___default.a.mock(/\/get\/i18n_type/, function () {
  return {
    code: 'success',
    data: {
      type: 'ZH_CN'
    },
    msg: 'ok'
  };
});

/***/ }),

/***/ "sEFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Headers: Headers
  }
});

/***/ }),

/***/ "sywW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vKIO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vTlb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wVPr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wtao":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("2sCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var ajax = {
  // 获取i18n种类
  GET_LANGUAGE_TYPE: '/get/i18n_type',

  // 获取首页menuList
  GET_MENU_LIST: 'homePageMenuImgList'

  // 获取头部导航菜单
  // GET_HEADER_LIST: '/headerList',
};

// 获取单个影像件
var GET_IMAGE_BYTE = 'attachment/v1/media/byte';

// 获取有权限的子菜单
var GET_GRANTED_SUBMENU = 'platform/v1/resources/granted/submenu';

var API_PATH_PRE_FIX = '/api';

// 增加前缀
var INTERFACE = {};
for (var key in ajax) {
  INTERFACE[key] = API_PATH_PRE_FIX + ajax[key];
}

var FIRST_PARAM_JOINT_MARK = '?';

// 退出系统
var LOGOUT = 'auth/user/logout';

/**
 * 获取 i18n 的种类
 */
function getI18nType() {
  // 这里需要先调用后端保存的语言
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(INTERFACE.GET_LANGUAGE_TYPE);
}

/**
 * 获取i18n 配置json
 *
 * @param language
 * @private
 */
function getI18n() {
  var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'zh';

  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/static/i18n/' + language + '/index.json' + '?').then(function (data) {
    window.I18n = data;
  });
}

/**
 * 获取头部导航菜单
 */
// function getHeaderList() {
//   return axios.get(INTERFACE.GET_HEADER_LIST).catch(function (error) {
//     console.log(error)
//   });
// }
function getHeaderList() {
  var data = {
    parentMenuValue: '/',
    serviceName: window.localStorage.serviceName,
    httpMethod: 'GET',
    parentType: 'FRONTEND_DOMAIN',
    childType: 'FRONTEND_URL'
  };
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(GET_GRANTED_SUBMENU + '?', { params: data }).catch(function (error) {
    console.log(error);
  });
}

/**
 * 获取首页menuList
 */
function getMenuList() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(INTERFACE.GET_MENU_LIST).catch(function (error) {
    // window.Alert(error);
    console.log(error);
  });
}

/**
 * 获取单个影像件
 * @param data
 * @returns {Promise.<T>}
 */
function getImageByte(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(GET_IMAGE_BYTE + FIRST_PARAM_JOINT_MARK, {
    params: data
  }).catch(function (error) {
    // window.Alert(error);
    console.log(error);
  });
}

function getPolicyIstrue(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('policy/v1/ciq/verify?', {
    params: data
  }).catch(function (error) {
    // window.Alert(error);
    console.log(error);
  });
}

function getPolicyDetail(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('policy/v1/ciq/policy?', {
    params: data
  }).catch(function (error) {
    // window.Alert(error);
    console.log(error);
  });
}

function getPolicyeBook(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('policy/v1/policy/email?', {
    params: data
  }).catch(function (error) {
    // window.Alert(error);
    console.log(error);
  });
}

function logout() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(LOGOUT + FIRST_PARAM_JOINT_MARK).catch(function (error) {
    // window.Alert(error);
    console.log(error);
  });
}

function printPdf(data) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('policy/v1/policy/download', data).catch(function (error) {
    // window.Alert(error);
    console.log(error);
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getI18n: getI18n,
  getI18nType: getI18nType,
  getHeaderList: getHeaderList,
  getImageByte: getImageByte,
  getMenuList: getMenuList,
  logout: logout,
  getPolicyIstrue: getPolicyIstrue,
  getPolicyeBook: getPolicyeBook,
  getPolicyDetail: getPolicyDetail,
  printPdf: printPdf
});

/***/ }),

/***/ "zcWg":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpDREQzMUYwMDBCMkUxMUU4ODFEQkJBNTJDODMwOUI0NiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpDREQzMUYwMTBCMkUxMUU4ODFEQkJBNTJDODMwOUI0NiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkNERDMxRUZFMEIyRTExRTg4MURCQkE1MkM4MzA5QjQ2IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkNERDMxRUZGMEIyRTExRTg4MURCQkE1MkM4MzA5QjQ2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+DBIVwwAAAkhJREFUeNqslk1IFVEUx+dNmVkgJgZpCqULKzNaVW4EN+WiQAjRjYKrp4K5MT9aaNEmojYVoQtBI9LWEaFSGxXBD8QPcKGgC8VnoqKLBBXtd+AMPGVm7jx8F36cmXnn/M+5c+/c80KWYXz83GFj7kI+pMIR/IVZmKmrDR/5xYd8hLMw9VAJlz3cVqEb3pFow83hrIuwJG2AV5AEy/IYxvT6DGTCfSiBZrgIz4wzQPwc5hs8VbEm6KW6Q49ZJmCKYRJkBgX4/nFNoJV/h1Loh3Kct6yAg/gwph3uEDfj9orqVXwAnuC0Z8U2eiCii398BmRPxyzANtxGfNOjyhbMNX4P+8ykUNewAr9tO6r6C/DCS1zHIygzzCRb3gDUyo2t774C1uCrdfoh67ijmpbM4CZkwA+qPzitOhq7mF+iS/EZkuCW/jZmxW84WvmSIE1vInFMsKo2VRI4H5EdxwR29MWaXmcGCNyH3QB+jlZEEkzpzYMAgTXwOIBfgdpZm1Vf4mJe9i6rnmQIXJQj2nBkXMI8hAm015131QnJWqHf6IVxg498tOehK3oxOmAd2qjguiFBu0/1NzCNehJ3njxNy1RgGgrlHIll2xAvTWkQcmWdiP95bDvxQD7x93LcwjABOTGI52GGVPylI+7WcOT+jU7zH7yFD159QauWTvYcEqEV39fGnkygtMJPcBWkL/yGUVjRGKdlFoF0NdmJ1Yj3xdL0ZctWadO/5+IrJ8CI7pYvXg0qFPAdp2Bkh1zRvy1ybs0humOK/S/AAEVWtSWKa8SWAAAAAElFTkSuQmCC"

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.fbd9d9ed35fdce3d57a2.js